module.exports = __webpack_public_path__ + "bedfd09cdff597d74a3315db03d3e05c.pdf";